import { v4 as uuidv4 } from 'uuid';

export function ProductQuantity(props) {
	return {
		componentName: 'ProductQuantity',
		componentId: uuidv4(),
		props: {
			blockClass: 'some-class',
			size: 'medium',
			showLabel: true,
			showUnit: true,
			quantitySelectorStep: 'unitMultiplier',
			selectorType: 'stepper',
			warningQuantityThreshold: 20,
			...props,
		},
		childrenComponents: [],
	};
}
